import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { JobcardService } from "../../../../../services/jobcard.service";
import { PartnerService } from "../../../../../services/partner.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-move-jobcard',
  templateUrl: './move-jobcard.component.html',
  styleUrls: ['./move-jobcard.component.scss']
})
export class MoveJobcardComponent implements OnInit {

  @Input() jobcard;
  @Input() partnerID;
  @Input() otherShops;
  @Input() originalServiceTypes;
  @Input() originalServiceTypeNames;
  @Input() messageService;
  @Output() showMoveJobcardDialog = new EventEmitter();
  @Output() jobCardMoved = new EventEmitter();

  public NewPartnerID: any = 0;
  public NewTechnicianID: any;
  public selectedServiceTypes: any = [];
  public shopList: any = [];
  public technicianList: any = [];
  public serviceTypes: any = [];
  public originalServiceTypesList : any = [];
  public movingJobcard : boolean = false;

  constructor(
    public jobcardService: JobcardService,
    public partnerService: PartnerService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.shopList = [{ label: this.translate.instant('bikeshop.modal.update_job_card.job_card.select_a_shop'), value: 0 }, ...this.otherShops.map(x => { return { label: x.name, value: x.id } })];

    this.originalServiceTypesList = this.originalServiceTypeNames.filter(x=>{return this.originalServiceTypes.indexOf(x.value) > -1});

  }

  shopSelected() {
    this.technicianList = [];
    this.serviceTypes = [];
    this.selectedServiceTypes = [];
    this.NewTechnicianID = null;

    if (this.NewPartnerID > 0) {
      this.jobcardService.getOtherShopTechnicianList(this.NewPartnerID).subscribe(result => {
        if (result && result.length > 0) {
          this.technicianList = result.map(x => { return { label: x.firstname + ' ' + x.surname, value: x.id } });
          this.NewTechnicianID = this.technicianList[0].value;
        } else {
          this.technicianList = [];
        }
      }, err => {
        this.technicianList = [];
      });

      this.partnerService.getPartnerServiceTypesDropDowns(this.NewPartnerID).subscribe(serviceTypes => {
        var GroupName = "";
        var serviceTypes_temp = [];
        serviceTypes
          .filter((serviceType) => {
            return serviceType.IsActive;
          })
          .map((serviceType) => {
            serviceType.GroupName = serviceType.GroupName
              ? serviceType.GroupName
              : this.translate.instant("general.not_grouped");
            if (serviceType.GroupName !== GroupName) {
              GroupName = serviceType.GroupName;
              serviceTypes_temp.push({
                label: serviceType.GroupName,
                value: -1,
                disabled: true,
              });
            }
            serviceTypes_temp.push({
              label: serviceType.ServiceTypeDescription,
              value: serviceType.ID,
              hours: serviceType.Hours,
              cost: serviceType.Cost,
            });
          });
          serviceTypes_temp.forEach(serviceType => {
            if(this.originalServiceTypesList.map(x=>{return x.label}).indexOf(serviceType.label) > -1){
              this.selectedServiceTypes.push(serviceType.value);
            }
          });
          this.serviceTypes = serviceTypes_temp;
      }, err => {
        this.selectedServiceTypes = [];
      })
    }

  };

  validateForm(){
    return this.NewPartnerID > 0 && this.NewTechnicianID > 0 && this.selectedServiceTypes.length > 0;
  }

  cancel(){
    this.showMoveJobcardDialog.emit();
  }

  moveJobCard(){
    var data = {
      PartnerID: this.partnerID,
      NewPartnerID: this.NewPartnerID,
      NewTechnicianID: this.NewTechnicianID,
      ServiceID: this.jobcard.ID,
      NewServiceTypes: this.selectedServiceTypes
    }
    this.movingJobcard = true;
    this.jobcardService.moveJobCard(data).subscribe(result=>{
      this.movingJobcard = false;
      this.jobCardMoved.emit({shopName: this.shopList.filter(x=>{return x.value === this.NewPartnerID}).pop().label});
    },err=>{
      this.movingJobcard = false;
    })
  }

}
